﻿import { SalesOrderSetInfo } from '~/features/catalog/components/article/SalesOrderSetInfo.tsx';
import { PriceBadgeGroup } from '~/common/components/PriceBadgeGroup.tsx';
import { cn } from '~/common/utils/styleUtil.ts';

export default function ArticleAghInfoIcons({
  article,
  className,
  isAuthenticated
}: Readonly<{
  className?: string;
  article: {
    isInSalesOrderSet: boolean;
    noveltyUntil: boolean;
    isHit?: boolean;
  };
  isAuthenticated: boolean;
}>) {
  return (
    <div className={cn('gap-2 min-w-0', className)}>
      {article.isInSalesOrderSet && <SalesOrderSetInfo />}
      <PriceBadgeGroup
        badges={[
          ...(article.noveltyUntil ? [{ type: 'new' as const }] : []),
          ...(article.isHit && isAuthenticated ? [{ type: 'hit' as const }] : [])
        ]}
      />
    </div>
  );
}
